<template>
  <section>
    <gs-header title="Thêm mới bài viết"
      :breadcrumbs="[
        {title: 'Quản lý bài viết', route: {name: 'blog'}}
      ]"
    >
    </gs-header>
    <div class="padding-all">
      <el-form :model="localBlog" :rules="rules" ref="createBlogForm" label-width="200px" label-position="top" @submit.prevent.native="validateBeforeSubmitBlog('createBlogForm')">
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="Tiêu đề" prop="title">
              <el-input v-model="localBlog.title" placeholder="Tiêu đề"></el-input>
            </el-form-item>
            <el-form-item label="Nội dung viết tắt" prop="teaser">
              <el-input type="textarea" :rows="4" v-model="localBlog.teaser" placeholder="Nội dung viết tắt"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Ảnh bài viết">
              <el-upload
                class="avatar-uploader"
                :action="uploadImageUrl"
                :headers="uploadHeader"
                :show-file-list="false"
                :on-success="handleImageUpload"
                >
                <img v-if="image.path" :src="image.path" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="Chọn loại bài viết" prop="type" class="is-required">
              <el-select
                class="width-100"
                v-model="localBlog.type"
                filterable
                placeholder="Chọn loại bài viết"
                @change="getCategories"
                >
                <el-option
                  v-if="blogHelpers.types"
                  v-for="(type, key, index) in blogHelpers.types"
                  :key="index"
                  :label="type"
                  :value="key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Chọn danh mục" prop="category_id" class="is-required">
              <el-select
                class="width-100"
                v-model="localBlog.category_id"
                filterable
                placeholder="Chọn danh mục"
                >
                <el-option
                  v-for="category in categories"
                  :key="category.id"
                  :label="category.name"
                  :value="category.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Trạng thái" prop="active">
              <el-radio-group v-model="localBlog.active">
                <el-radio v-for="(status, key, index) in blogHelpers.statuses" :key="key" class="radio" v-model="localBlog.active" :label="key">{{status}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Hot">
              <el-checkbox name="hot" v-model="localBlog.hot">Hot</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Hiển thị trang shop">
              <el-checkbox name="show_on_shop" v-model="localBlog.show_on_shop">Hiển thị trang shop</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Tags" prop="tags">
              <el-select class="display-block"
                v-model="suggettionTag"
                filterable
                remote
                placeholder="Nhập tag..."
                :remote-method="selectTag"
                :loading="fetchTag"
                @change="selectSuggettionTag"
                >
                <el-option
                  v-for="item in listTags"
                  :key="item.id"
                  :value="item"
                  :label="item.tag"
                  >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            &nbsp;
          </el-col>
          <el-col :span="4">
            <el-form-item label="Hiển thị trang landing">
              <el-checkbox name="show_on_shop" v-model="localBlog.show_on_landing">Hiển thị trang landing</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="Danh sách tags">
              <el-tag
                v-for="tag in selectedTags"
                class="margin-sm-right"
                :closable="true"
                type="primary"
                :key="tag.id"
                @close="removeTag(tag)"
              >
              {{tag.tag}}
              </el-tag>
              <el-input
                class="input-new-tag"
                v-if="inputVisible"
                v-model="inputValue"
                ref="saveTagInput"
                size="mini"
                @blur="handleInputConfirm"
              >
              </el-input>
              <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <p v-if="imageContent.path"><span>Đường dẫn: </span> <span class="text-blue">{{imageContent.path}}</span></span></p>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="Nội dung bài viết" prop="content" class="blog-content">
              <el-input
                name="content"
                type="textarea"
                autosize
                placeholder="Nội dung bài viết"
                v-model="localBlog.content">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Upload ảnh nội dung bài viết">
              <el-upload
                class="avatar-uploader"
                :action="uploadImageUrl"
                :headers="uploadHeader"
                :show-file-list="false"
                :on-success="handleImageContentUpload"
                >
                <img v-if="imageContent.path" :src="imageContent.path" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <button class="ui blue basic small button" native-type="submit"><i class="fa fa-plus"></i> Thêm mới</button>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
import { addBlog } from 'src/api/blogs'
import { head } from 'lodash'
import mixins from './mixins'
export default {

  name: 'NewBlog',
  mixins: [mixins],
  methods: {
    validateBeforeSubmitBlog () {
      this.localBlog.content = this.simplemde.value()
      this.$refs.createBlogForm.validate(valid => {
        if (valid) {
          this.changedData = false
          this.watching = false
          addBlog(this.localBlog).then(response => {
            switch (response.code) {
              case 200:
                this.$store.dispatch('showNotify', {
                  title: 'Thêm mới thành công',
                  body: 'Thêm bài viết thành công'
                })
                this.reloadGsTableAfterRedirect({name: 'blog'}, 'blogs')
                this.toggleLoadding(false)
                break
              case 422:
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.toggleLoadding(false)
                break
              default:
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: 'Thêm bài viết thất bại',
                  type: 'warning'
                })
                this.toggleLoadding(false)
            }
          })
        } else {
          this.$store.dispatch('toggleLoadding', false, {root: true})
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          this.watching = true
          return false
        }
      })
    }
  },
  mounted () {}
}
</script>

<style lang="css">
.CodeMirror .cm-spell-error:not(.cm-url):not(.cm-comment):not(.cm-tag):not(.cm-word) {
  background: none !important;
}
.blog-content .el-form-item__error {
  top: 90%;
}
</style>



// WEBPACK FOOTER //
// NewBlog.vue?78a24dc8